document.addEventListener('DOMContentLoaded', function() {
  let feeding_tabs = document.querySelector('.feeding_tabs');
console.log(feeding_tabs);
  if (feeding_tabs !== null) {
    let active_tab = 'dog_content_tab';
    let current_active_tab = document.querySelector(`.${active_tab}`);
    current_active_tab.classList.add('active');

    let tabs = document.querySelectorAll('.tab_item');
    tabs.forEach(element => {
      element.addEventListener('click', function(){
        let target = this.dataset.target;
        let activeContent = document.querySelector('.content_tab.active');
        activeContent.classList.remove('active');
        document.querySelector(`.${target}`).classList.add('active');
        let activeTab = document.querySelector('.tab_item.active');
        activeTab.classList.remove('active');
        this.classList.add('active');
      })
    })
  }

  let eber = document.querySelector('.eber-container');
console.log(eber);
  if (eber !== null) {
    eber.remove();
  }
})